fragment ReplyTaskEmailScannerFragment on ReplyTaskEmailScanner {
    id

    uid

    from
    to

    from_name
    to_name

    header
    subject

    body
    eml_data

    parsedBody

    hash

    folder
    client_username

    datetime
    processed_datetime

    created_at
    updated_at
}